module.exports = __webpack_public_path__ + "img/userRes_c.308491da.png";